import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import VehiclePicture from "./VehiclePicture";
import "./VehiclePictureCarousel.scss";
import carouselClass from "./VehiclePictureCarousel.scss.json";
import cx from "classnames";

const VehiclePictureCarousel = ({id, pictures, height, vehicleType}) => {
    const hasMultiplePictures = (pictures?.length ?? 0) > 1;
    return (
        <Carousel
            style={{
                width: '100%',
                height: height ?? 'auto',
                aspectRatio: height ? undefined : '4/3',
                borderRadius: '5px',
            }}
            interval={null}
            controls={hasMultiplePictures}
            indicators={hasMultiplePictures}
            prevIcon={hasMultiplePictures ? <span className={cx(carouselClass.arrow, carouselClass.left, 'bg-light')} /> : null}
            nextIcon={hasMultiplePictures ? <span className={cx(carouselClass.arrow, carouselClass.right, 'bg-light')} /> : null}
        >
            {pictures?.map((picture, index) => {
                return <Carousel.Item className='bradius-5' key={`picture_carousel_item_${id}_${index}`}>
                    <VehiclePicture
                        url={picture?.url ?? picture?.large_url}
                        vehicleType={vehicleType}
                        height={'100%'}
                        fit={"contain"}
                        // square
                    />
                </Carousel.Item>
            })}
        </Carousel>

    );
};

export default VehiclePictureCarousel;
